module.exports = __webpack_public_path__ + "img/position.a5d9ba6e.png";